import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import BackButtonPicker
  from './BackButtonPicker';

const styles = theme => ({
  root: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    gap: `${theme.spacing(2)}px`,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 2),
    width: '100%',
  },
  titleItem: {
    flexGrow: 1,
  },
});

const Header = ({ className, classes }) => {
  const { pageContentResource } = usePageContentContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <Box className={classes.headerItem}>
        <BackButtonPicker />
      </Box>
      <Box className={classes.titleItem}>
        <Typography variant={'h2'} weight={'bold'} color={'primary'}>
          {pageContentResource.attr('title')}
        </Typography>
      </Box>
    </Box>
  );
};

Header.defaultProps = {
  className: '',
};

Header.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);
